import Cookies from 'js-cookie'
import { getLanguage } from '@/lang/index'
const customThemes = {
  default: {
    value: 'default',
    main: '#409EFF',
    slideColor: '#304156',
    textColor: '#ffffff',
    slideActiveColor: '#f0f0f0',
    headerColor: '#222632',
    name: '默认皮肤',
    type: 1
  },
  custom: {
    value: 'custom',
    main: '#409EFF',
    slideColor: '#304156',
    textColor: '#ffffff',
    slideActiveColor: '#f0f0f0',
    headerColor: '#222632',
    name: '自定义皮肤',
    type: 2
  },
  red: {
    value: 'red',
    main: '#F5646C',
    slideColor: '#F5646C',
    textColor: '#ffffff',
    slideActiveColor: '#ffffff',
    headerColor: '#F5646C',
    name: '红',
    type: 2
  },
  young: {
    value: 'young',
    main: '#63D8D2',
    slideColor: '#63D8D2',
    textColor: '#ffffff',
    slideActiveColor: '#ffffff',
    headerColor: '#63D8D2',
    name: '青',
    type: 2
  },
  green: {
    value: 'green',
    main: '#259C6A',
    slideColor: '#259C6A',
    textColor: '#ffffff',
    slideActiveColor: '#ffffff',
    headerColor: '#259C6A',
    name: '绿',
    type: 2
  },
  orange: {
    value: 'orange',
    main: '#FFAE00',
    slideColor: '#FFAE00',
    textColor: '#ffffff',
    slideActiveColor: '#ffffff',
    headerColor: '#FFAE00',
    name: '橙',
    type: 2
  },
  blue: {
    value: 'blue',
    main: '#0991EB',
    slideColor: '#0991EB',
    textColor: '#ffffff',
    slideActiveColor: '#ffffff',
    headerColor: '#0991EB',
    name: '蓝',
    type: 2
  },
  purple: {
    value: 'purple',
    main: '#A05AD9',
    slideColor: '#A05AD9',
    textColor: '#ffffff',
    slideActiveColor: '#ffffff',
    headerColor: '#A05AD9',
    name: '紫',
    type: 2
  },
  ywcq: {
    value: 'ywcq',
    main: '#78A3E7',
    slideColor: '#FFFFFF',
    textColor: '#204D95',
    slideActiveColor: '#204D95',
    headerColor: '#204D95',
    fastCardColor: '#F8C975',
    name: '仰望苍穹',
    type: 3
  },
  qqzj: {
    value: 'qqzj',
    main: '#118FA8',
    slideColor: '#FAFAF5',
    textColor: '#1E6B8F',
    slideActiveColor: '#1E6B8F',
    headerColor: '#118FA8',
    fastCardColor: '#F5D193',
    name: '青青子衿',
    type: 3
  },
  fyhl: {
    value: 'fyhl',
    main: '#FFB2B2',
    slideColor: '#FFFFFF',
    textColor: '#804040',
    slideActiveColor: '#804040',
    headerColor: '#804040',
    fastCardColor: '#93C4F5',
    name: '枫叶红了',
    type: 3
  }

}
// const OEMInfo =
const themeName = Cookies.get('client-theme') || 'default'
const clientColor = Cookies.get('client-color') || '#72777D'
const app = {
  state: {
    clientColor: clientColor,
    menuSize: Cookies.get('client-menuSize') || 'normal',
    language: getLanguage(),
    OEMInfo: {
      ProductShortName: 'Workfine', // 产品简称
      CompanyEnglishName: 'Wuxi Benniu Co.,Ltd.', // 公司英文简写
      CompanyHomePage: 'https://www.bn100.com', // 公司官网
      CompanySupport: 'https://help.bn100.com' // 公司联系信息
    },
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    themeName: themeName,
    theme: customThemes[themeName],
    customThemes: customThemes,
    device: 'desktop',
    defaultPercent: 14,
    disableTree: false,
    showRefresh: false,
    backgroundColor: '#0991EB', // #304156
    textColor: '#ffffff', // #bfcbd9
    activeTextColor: '#409EFF',
    logoBackgroundColor: '#222632', // #1f2d3d
    formFilter: null,
    temporaryId: null,
    copyCreateRID: null,
    onlyOfficeSetting: { active: false },
    fontList: [],
    fillInfo: undefined
  },
  mutations: {
    // 颜色选择器
    SET_CUSTOMTHEME: (state, theme) => {
      state.theme = theme
    },
    CHANGE_DEFAULTPERCENT: (state, defaultPercent) => {
      state.defaultPercent = defaultPercent
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1, { expires: 365 })
      } else {
        Cookies.set('sidebarStatus', 0, { expires: 365 })
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    CHANGE_THEME: (state, themeName) => {
      state.themeName = themeName
      state.theme = customThemes[themeName]
      Cookies.set('client-theme', themeName, { expires: 365 })
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language, { expires: 365 })
    },
    SET_MENUSIZE: (state, menuSize) => {
      state.menuSize = menuSize
      Cookies.set('client-menuSize', menuSize)
    },
    SET_REFRESH_STATUS: (state, status) => {
      state.showRefresh = status
    },
    SET_DISABLE_TREE: (state, status) => {
      state.disableTree = status
    },
    SET_OEM_INFO: (state, status) => {
      state.OEMInfo = status
    },
    SET_FORM_FILTER: (state, status) => {
      state.formFilter = status
    },
    SET_TEMPORARY_ID: (state, status) => {
      state.temporaryId = status
    },
    SET_COPY_CREATE_RID: (state, status) => {
      state.copyCreateRID = status
    },
    SET_ONLYOFFICE_SETTING: (state, setting) => {
      state.onlyOfficeSetting = setting
    },
    SET_FONTLIST: (state, list) => {
      state.fontList = list
    },
    SET_FILLINFO: (state, fillInfo) => {
      state.fillInfo = fillInfo
    }
  },
  actions: {
    // 颜色选择器
    setCustomTheme({ commit }, theme) {
      commit('CHANGE_THEME', 'custom')
      commit('SET_CUSTOMTHEME', theme)
      Cookies.set('client-color', theme.main, { expires: 365 })
    },
    changeDefaultPercent({ commit }, defaultPercent) {
      commit('CHANGE_DEFAULTPERCENT', defaultPercent)
      localStorage.setItem('defaultPercent', defaultPercent, { expires: 365 })
    },
    setMenuSize({ commit }, menuSize) {
      commit('SET_MENUSIZE', menuSize)
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    ChangeTheme({ commit }, themeName) {
      commit('CHANGE_THEME', themeName)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setRefreshStatus({ commit }, status) {
      commit('SET_REFRESH_STATUS', status)
    },
    setDisableTree({ commit }, status) {
      commit('SET_DISABLE_TREE', status)
    },
    setOEMInfo({ commit }, status) {
      commit('SET_OEM_INFO', status)
    },
    setFormFilter({ commit }, status) {
      commit('SET_FORM_FILTER', JSON.parse(JSON.stringify(status)))
    },
    setTemporaryId({ commit }, status) {
      commit('SET_TEMPORARY_ID', status)
    },
    setCopyCreateRID({ commit }, status) {
      commit('SET_COPY_CREATE_RID', status)
    },
    setOnlyOfficeSetting({ commit }, setting) {
      commit('SET_ONLYOFFICE_SETTING', setting)
    },
    setFontList({ commit }, list) {
      commit('SET_FONTLIST', list)
    },
    setFillInfo({ commit }, fillInfo) {
      commit('SET_FILLINFO', fillInfo)
    }
  }
}

export default app
